import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import walk1 from "../../assets/images/walk1.jpg"
import walk2 from "../../assets/images/walk2.jpg"
import walk3 from "../../assets/images/walk3.jpg"
import walk4 from "../../assets/images/walk4.jpg"
import walk5 from "../../assets/images/walk5.jpg"
import walk6 from "../../assets/images/walk6.jpg"
import LeftSection from "../../components/organisms/LeftSection";
import RightSection from "../../components/organisms/RightSection";
import styled from "styled-components";
import {device} from "../../assets/styles/media.js";

const Text = styled.div`
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;
    ${device.mobile} {
        font-size: 14px;
    }
`;
const List = styled.ul`
    margin-top: 10px;
    margin-bottom: 20px;
    ${device.mobile} {
        margin-top: 20px;
    }
`;
const Item = styled.li`
    display: block;
    color: #444444;
    line-height: 23px;
    letter-spacing: -0.7px;
    ${device.mobile} {
        font-size: 13px;
    }
`;

const WalkPath = () => {

    const list = [
        '* 일정에 따라 한시적으로 오프리시로 운영됩니다.',
        '* 도그 스포츠 등 다양한 행사가 진행됩니다.',
        '* 각종 사고를 예방하기 위해 소중한 강아지를 꼭 가까이서 케어해주세요.',
        '* 도그 스포츠 공간은 훈련 공간이므로 사용이 불가능합니다.',
        '* 상주견들 훈련시에는 잠시 산책줄 착용 요청이 있을 수 있습니다.',
    ]
    const list2 = [
        '연못을 둘러싼 둘레길을 따라 사계절 자연의 아름다움이 흐릅니다.',
        '정원을 옮겨놓은 듯한 수려함이 발길 닿는 곳마다 소박한 행복을 안겨줍니다.',
    ]
    const list3 = [
        '야자매트가 깔린 산길을 편안히 걸으며 하얀 자작나무들의 인사를 받습니다.',
        '나란히 함께 걸으면 더욱 아름다운 산책로입니다.',
    ]
    const list4 = [
        '* 산책 시의 편안함을 위해 야자매트가 바닥에 깔려 있습니다.',
        '* 안전을 위해 정해진 산책 동선 이외의 길로는 진입이 제한됩니다.'
    ]
    const textList2 = '사계절을 담는 고즈넉한 자연 연못입니다.';
    const textList3 = '함께 걸으면 더욱 아름답습니다.';
    return (
        <>
            <PageHeader
                bTitle="관람"
                detail="산책"
                desc="강아지숲 산책 공간을 안내해 드립니다."
            />

            {/*section 1*/}
            <LeftSection
                title="강아지숲 동산"
                enTitle="d.forest Playland"
                content={<><Text>여유로움이 묻어나는 너른 잔디마당 입니다.
                    잔디 내음이 강아지의 후각을 자극하여 기분을 좋게 만들어줍니다. 햇살과 바람, 여유로움까지 누릴 수 있는 강아지숲 동산입니다.</Text>
                    <List>
                        {list.map((item, index) => (<Item key={index}>{item}</Item>))}
                    </List>
                </>}
                img1={walk1}
                img2={walk2}
                simbolId={"pond"}
            />

            {/*section 2*/}
            <RightSection
                title="강아지숲 연못"
                enTitle="d.forest Pond"
                textList={textList2}
                content={<List>
                    {list2.map((item, index) => (<Item key={index}>{item}</Item>))}
                </List>}
                img1={walk3}
                img2={walk4}
                simbolId={"walk"}
            />
            {/*section 3*/}
            <LeftSection
                title="강아지숲 산책로"
                enTitle="d.forest Walk"
                textList={textList3}
                content={<>
                    <List>
                        {list3.map((item, index) => (<Item key={index}>{item}</Item>))}
                    </List>
                    <List>
                        {list4.map((item, index) => (<Item key={index}>{item}</Item>))}
                    </List>
                </>}
                img1={walk5}
                img2={walk6}
                simbol={false}
            />
        </>
    );
};

export default WalkPath;
